<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('order_deduction_item') || '费用填报明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('INDEX.btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:customer="{ row }">
        <dict-select
          v-model="row.custCode"
          :selectedLabel.sync="row.custName"
          url="/master/common/dict/customerSelect"
          filterable
          clearable
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        ></dict-select>
      </template>
      <template v-slot:scmName="{ row }">
        <dict-select
          v-model="row.scmCode"
          :selectedLabel.sync="row.scmName"
          url="/master/common/dict/allScmCooperated"
          filterable
          clearable
        ></dict-select>
      </template>
      <template v-slot:custOrderNo="{ row }">
        <OrderSelect
          :orderCode.sync="row.orderCode"
          :custOrderNo.sync="row.custOrderNo"
          :custCode="row.custCode"
        />
      </template>
      <template v-slot:depCode="{ row }">
        <dep-cascader
          size="small"
          ref="dep"
          :lastValue.sync="row.depCode"
          :valueString.sync="row.displayDepCode"
          :pathLabels.sync="row.orgDepFullName"
          :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderSelect from '@/views/factory/components/order-select'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  components: { OrderSelect },
  props: {
    disabled: { type: Boolean, default: false },
    orderDeductionCode: { type: String, default: '' },
    depCode: { type: String, default: '' },
    orgDepFullName: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
      validRules: {
        currencyAmount: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_currency_amount_must_be_greater_than_0') ||
              '费用金额须大于0',
          },
        ],
        deductionType: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('form_placeholder_deductionType') || '请选择项目费用',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.orderDeductionCode) return
      this.$api
        .orderDeductionItemListApi({
          orderDeductionCode: this.orderDeductionCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable
      const { row: newRow } = await $itemTable.insertAt(
        { depCode: this.depCode, orgDepFullName: this.orgDepFullName },
        -1
      )
      await $itemTable.setActiveCell(newRow, 'currencyAmount')
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount()
    },
    async subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      const scmCurrencyAmount = data.reduce(
        (result, next) => add(result, next.scmCurrencyAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
      this.$emit('updateScmTotAmount', scmCurrencyAmount)
    },
  },
}
</script>
